import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Modal, Row, Space, Table, Typography, message } from "antd";
import { TablePaginationConfig } from "antd/lib/table";
import { Consditions, IuserProfile } from "../models/models-datamanagement";
import dayjs from "dayjs";
import { useId24 } from "../../../drivers/id24/Id24-provider";
import { loadAppConfig } from "../../../config/app-config";
import { DatamanagementService } from "../services/datamanagement-service";
import NumberFormat from "react-number-format";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { checknumberformat, checkspecialfont } from "../../../utils/helper-form";

interface Props {
  tab: { key: string; label: string };
  loading: boolean;
  setLoading: (state: boolean) => void;
  baseUrl: string;
  accessRole: any;
}

const { Text } = Typography;

export interface FilterTable {
  take: number;
  skip: number;
}

export const TableDataManagementUnlist: React.FC<Props> = ({ tab, loading, setLoading, accessRole }): React.ReactElement => {
  const csvDownload = useRef<any | null>(null);
  const appConfig = loadAppConfig();
  const { id24Axios } = useId24();
  const apiBaseUrlCore = id24Axios(appConfig.apiBaseUrl);
  const apiBaseUrlDebt = id24Axios(appConfig.apiBaseUrlDebt);
  const [dataSource, setDataSource] = useState<Consditions[]>([]);
  const [csvData, setCsvData] = useState([]);
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
  });
  const [userProfile, setUserprofile] = useState<IuserProfile>({
    id: 0,
    level: "",
    name: "",
    oaCode: "",
    parentId: "",
    team: "",
    token: "",
    type: "",
    capabilities: {},
  });

  useEffect(() => {
    const getDataCount = async () => {
      const resultCountUnlist: any = await DatamanagementService(apiBaseUrlDebt).getCountUnList();
      setPagination({
        total: resultCountUnlist[0]?._count?.UserId,
      });
      getUserProfile();
    };
    const getUserProfile = async () => {
      return new Promise<IuserProfile>(async (resolve, reject) => {
        const resualProfile = await DatamanagementService(apiBaseUrlDebt).getUserDetail();
        resolve(resualProfile);
        setUserprofile(resualProfile);
      });
    };
    const getData = async () => {
      const current = pagination.current || 1;
      const take = pagination.pageSize || 10;
      const skip = (current - 1) * take;
      const filter = {
        take,
        skip,
      };
      const result = await DatamanagementService(apiBaseUrlDebt).getUnlistList(filter);
      if (result.length > 0) {
        const data = result.map((d: any, index: number) => {
          return {
            key: index + skip + 1,
            ...d,
          };
        });
        setDataSource(data);
      } else {
        setDataSource([]);
      }
    };
    getDataCount();
    getData();
    setLoading(false);
  }, [tab, loading]);

  const columns = [
    {
      title: "No.",
      dataIndex: "key",
    },
    {
      title: "CIF",
      dataIndex: "cif",
      key: "cif",
    },
    {
      title: "Account No.",
      dataIndex: "accountno",
      key: "accountno",
    },
    {
      title: "ชื่อลูกหนี้",
      dataIndex: "custname",
      key: "custname",
    },
    {
      title: "จำนวนเงินค้างชำระ",
      dataIndex: "osbal",
      key: "osbal",
      align: "right" as const,
      render: (text: string, record: any, index: number) => (
        <NumberFormat value={text} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={""} />
      ),
    },
    {
      title: "Worklist",
      dataIndex: "worklist",
      key: "worklist",
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "สีน้ำท่วม",
      dataIndex: "floodstatus",
      key: "floodstatus",
      // width: 200,
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "Bscore",
      dataIndex: "riskscore",
      key: "riskscore",
      // width: 200,
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "Billcode",
      dataIndex: "billcode",
      key: "billcode",
      // width: 200,
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "ประเภทลูกค้า",
      dataIndex: "custtype",
      key: "custtype",
      // width: 200,
      render: (text: string) => (text ? text : "-"),
    },
    {
      title: "Last Result",
      dataIndex: "lasttermcode",
      key: "lasttermcode",
      // width: 200,
      render: (text: string) => (text ? text : "-"),
    },
  ];

  const handlecleardataUnlist = async () => {
    Modal.confirm({
      title: "คุณแน่ใจแล้วใช่ไหม",
      icon: <ExclamationCircleOutlined />,
      content: "ยืนยันการลบข้อมูล Unlist ใช่หรือไม่",
      okText: "ยืนยัน",
      cancelText: "ยกเลิก",
      onOk: async () => {
        const resualclearUnlist = await DatamanagementService(apiBaseUrlCore).clearDataUnlist(userProfile);
        if (resualclearUnlist === "success") {
          message.success("Clear Unlist Success");
          location.reload();
        }
      },
      onCancel: () => {},
    });
  };

  const handleRecalldataUnlist = async () => {
    Modal.confirm({
      title: "คุณแน่ใจแล้วใช่ไหม",
      icon: <ExclamationCircleOutlined />,
      content: "ยืนยันการดึงงานกลับ ใช่หรือไม่",
      okText: "ยืนยัน",
      cancelText: "ยกเลิก",
      onOk: async () => {
        const result_clearUnlist = await DatamanagementService(apiBaseUrlCore).clearDataUnlistNouserZero(userProfile.id);
        if (result_clearUnlist === "success") {
          message.success("Recall Success");
          location.reload();
        }
      },
      onCancel: () => {},
    });
  };

  const setCsvList = async () => {
    try {
      const result = (await DatamanagementService(apiBaseUrlDebt).getUnlistList({
        take: pagination.total,
        skip: 0,
      })) as any as any;
      const data = result?.map((d: any, index: number) => {
        const datares = checknumberformat(d.granttotal);
        return {
          key: index + 1,
          // accountno: `=""${d.accountno}""`,
          accountno: d.accountno,
          granttotal: datares,
          billcode: d.billcode ? d.billcode : "-",
          cif: d.cif ? d.cif : "-",
          custname: d.custname ? d.custname : "-",
          custtype: d.custtype ? d.custtype : "-",
          dtllastpay: d.dtllastpay ? d.dtllastpay : "-",
          floodstatus: d.floodstatus ? d.floodstatus : "-",
          lasttermcode: d.lasttermcode ? d.lasttermcode : "-",
          osbal: d.osbal ? checknumberformat(d.osbal) : "-",
          riskscore: d.riskscore ? d.riskscore : "-",
          worklist: d.worklist ? d.worklist : "-",
        };
      });
      setCsvData(data);
      setTimeout(() => {
        csvDownload.current.link.click();
      });
    } catch (err) {
      message.error("ไม่พบข้อมูล");
    }
  };

  const csvHeader = [
    { key: "key", label: "No" },
    { key: "cif", label: "CIF" },
    { key: "accountno", label: "Account No" },
    { key: "custname", label: "ชื่อลูกหนี้" },
    { key: "osbal", label: "จำนวนเงินค้างชำระ" },
    { key: "worklist", label: "Worklist" },
    { key: "floodstatus", label: "สีน้ำท่วม" },
    { key: "riskscore", label: "Bscore" },
    { key: "billcode", label: "Billcode" },
    { key: "custtype", label: "ประเภทลูกค้า" },
    { key: "lasttermcode", label: "Last Result" },
  ];

  const checkAccessRole = (role: string) => {
    var result = accessRole.indexOf(role) > -1;
    if (result == true) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <Row style={{ marginTop: "1em" }}>
        <Col span={20} style={{ display: "flex", justifyContent: "start" }}>
          <Text strong>{tab.label}</Text>
        </Col>
        <Col span={4} style={{ display: "flex", justifyContent: "end" }}>
          Account : {pagination.total ? pagination.total : 0}
        </Col>
      </Row>
      <br></br>
      <Row>
        <Col span={24}>
          <Table
            dataSource={dataSource}
            columns={columns as any}
            size="small"
            pagination={{ total: Number(pagination.total) || 1, pageSize: pagination.pageSize, current: pagination.current }}
            loading={loading}
            onChange={(event: TablePaginationConfig) => {
              setPagination({ current: event.current, pageSize: event.pageSize });
              setLoading(!loading);
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "2em" }}>
        <Col span={24} style={{ justifyContent: "end", display: "flex" }}>
          <Space>
            {pagination?.total ? (
              <>
                <CSVLink
                  filename={`unlist-${dayjs(new Date()).locale("th").add(543, "year").format("YYYYMMDD")}.csv`}
                  className="btn btn-primary"
                  data={csvData}
                  headers={csvHeader}
                  target="_blank"
                  ref={csvDownload}
                  hidden={true}
                  asyncOnClick={false}
                ></CSVLink>
                <Button type="primary" style={{ border: "none" }} onClick={setCsvList}>{`Export CSV`}</Button>
              </>
            ) : (
              <>
                <CSVLink
                  filename={`unlist-${dayjs(new Date()).locale("th").add(543, "year").format("YYYYMMDD")}.csv`}
                  className="btn btn-primary"
                  data={csvData}
                  headers={csvHeader}
                  target="_blank"
                  ref={csvDownload}
                  hidden={true}
                  asyncOnClick={false}
                ></CSVLink>
                <Button type="primary" style={{ border: "none", backgroundColor: "#E5E4E2" }} onClick={setCsvList} disabled>{`Export CSV`}</Button>
              </>
            )}
            {checkAccessRole("ddebtDataManagementClearUnlist") ? (
              <>
                {pagination?.total ? (
                  <Button danger type="primary" style={{ border: "none" }} onClick={() => handlecleardataUnlist()}>{`Clear Unlist`}</Button>
                ) : (
                  <Button danger type="primary" style={{ border: "none", backgroundColor: "#E5E4E2" }} disabled>{`Clear Unlist`}</Button>
                )}
              </>
            ) : (
              <></>
            )}
            <Button type="primary" style={{ border: "none", backgroundColor: "orange" }} onClick={() => handleRecalldataUnlist()}>{`Recall`}</Button>
          </Space>
        </Col>
      </Row>
    </>
  );
};
